import styled from 'styled-components';
import moment from 'moment';
import { useLanguage } from '../../../../Context/LanguageContext';
import { useTheme } from '../../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../../Styles/theme';

import PencelImg from '../../../../image/GrayPencel.png';
import WhiteTrashIcon from '../../../../image/GrayTrash.png';


export default function ProductUsageInfoView (props) {
  const { t, isEng } = useLanguage();
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;
  const {
    data,
    index,
    size,
    onClickEditProductUsage,
    onClickDeleteProductUsage
  } = props;

  const fontColor = theme.subText;
  const border = `1px solid ${theme.subBackground}`;
  const hoverBorder = `1px solid ${theme.primary}`;
  const backgroundColor = theme.subBackground;


  // 링코페이 여부 확인 //
  function isLinkoPay() {
    if (!data.merchantUid) return false;
    const indicator = data.merchantUid.split('-')[2];
    return indicator === '1' || indicator === '2';
  }

  // 결제 금액 정리 //
  function decideTotalPriceView() {
    if (data.selectedPaymentOptions === undefined || data.selectedPaymentOptions.length === 0) {
      if (data.cardPrice === 0 && data.cashPrice === 0) return t('memberDetail.payFree');
      else if (data.cardPrice === 0) return data.cashPrice.toLocaleString('ko-KR') + ' - ' + t('memberDetail.payCash');
      else if (data.cashPrice === 0) return data.cardPrice.toLocaleString('ko-KR') + ' - ' + (isLinkoPay() ? t('memberDetail.payLinkoPay') : t('memberDetail.payCard'));
      else return (parseInt(data.cashPrice) + parseInt(data.cardPrice)).toLocaleString('ko-KR') + ' - ' + t('memberDetail.payCombined');
    }
    else {
      const allSame = data.selectedPaymentOptions.every(item => item.name === data.selectedPaymentOptions[0].name);
      const totalPrice = data.selectedPaymentOptions.reduce((sum, item) => sum + item.price, 0);

      const paymentNameMap = { '카드': isLinkoPay() ? t('memberDetail.payLinkoPay') : t('memberDetail.payCard'), '현금': t('memberDetail.payCash'), '포인트': t('memberDetail.payPoint') };
      if (totalPrice === 0) return t('memberDetail.payFree');
      else if (allSame) return totalPrice.toLocaleString('ko-KR') + ' - ' + (paymentNameMap[data.selectedPaymentOptions[0].name] || data.selectedPaymentOptions[0].name);
      else return totalPrice.toLocaleString('ko-KR') + ' - ' + t('memberDetail.payCombined');
    }
  }

  return (
    <TopLevelWrapper>
      <MemberShipComponent
        zIndex={20 + size - index}
        border={border}
        hoverBorder={hoverBorder}
        backgroundColor={backgroundColor}
        $isDark={isDark}>
      <Table>
        <Body>
          <Tr style={{ width: '428px' }}>
            <Td>
              <TextWrapper style={{ maxWidth: '410px' }}>
                <Text color={fontColor}>{data.itemName}</Text>
              </TextWrapper>
            </Td>
          </Tr>
          <Tr style={{ width: '164px' }}>
            <Td>
              <TextWrapper style={{ maxWidth: '158px' }}>
                <Text color={fontColor}>{decideTotalPriceView()}</Text>
              </TextWrapper>
            </Td>
          </Tr>
          <Tr style={{ width: '91px' }}>
            <Td>
              <TextWrapper style={{ maxWidth: '62px' }}>
                <Text color={fontColor}>{data.notReceivedPrice.toLocaleString('ko-KR')}</Text>
              </TextWrapper>
            </Td>
          </Tr>
          <Tr style={{ width: '220px' }}>
            <Td>
              <TextWrapper style={{ maxWidth: '93px' }}>
                <Text color={fontColor}>{isEng ? moment(data.approvalDate).format(t('partnerGym.history.dateFormat')) : data.approvalDate.slice(2, 10).replaceAll('-', '.')}</Text>
              </TextWrapper>
            </Td>
          </Tr>
          <Tr>
            <Td>
              <OptionButtonWrapper>
                <OptionButton src={PencelImg} onClick={() => onClickEditProductUsage(data)} />
                <OptionButton src={WhiteTrashIcon} onClick={() => onClickDeleteProductUsage(data)} />
              </OptionButtonWrapper>
            </Td>
          </Tr>
        </Body>
      </Table>
      </MemberShipComponent>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 1018px;
`;

const MemberShipComponent = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  width: 1018px;
  height: 50px;

  box-shadow: ${props => props.$isDark ? 'none' : '0px 10px 50px rgba(240, 232, 227, 0.5)'};

  z-index: ${props => props.zIndex};

  border: ${props => props.border};
  border-radius: 30px;
  background-color: ${props => props.backgroundColor};

  transition: all 0.3s ease-in-out;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
      border: ${props => props.hoverBorder};
    }
  }
`;

const Table = styled.table`
  display: flex;
  flex-direction: row;
`;

const Body = styled.tbody`
  display: flex;
  flex-direction: row;

  margin-left: 28px;
`;

const Tr = styled.tr`
  display: flex;
  flex-direction: row;
`;

const Td = styled.td`
  display: flex;
  flex-direction: row;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: flex-start;

  overflow: hidden;

  max-height: 20px;
`;

const Text = styled.span`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.color};

  margin: 0 0 0 0;
  padding: 0 0 0 0;
`;

const OptionButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 16px;
`;

const OptionButton = styled.img`
  width: 24px;
  height: 24px;

  transition: all 0.3s ease-in-out;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
    }
  }
`;
